module.exports = __webpack_public_path__ + "img/8.2290d05c.jpg";